import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pad15" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "10",
  rx: "2",
  ry: "2",
  width: "200",
  height: "100"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "120",
  rx: "4",
  ry: "4",
  width: "60",
  height: "10"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "150",
  rx: "4",
  ry: "4",
  width: "140",
  height: "10"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "180",
  rx: "4",
  ry: "4",
  width: "160",
  height: "10"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "10",
  rx: "2",
  ry: "2",
  width: "200",
  height: "100"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "120",
  rx: "4",
  ry: "4",
  width: "60",
  height: "10"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "150",
  rx: "4",
  ry: "4",
  width: "140",
  height: "10"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  x: "10",
  y: "180",
  rx: "4",
  ry: "4",
  width: "160",
  height: "10"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentLoader = _resolveComponent("ContentLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentLoader, {
      height: 200,
      style: {"width":"400px"},
      class: "fl"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_ContentLoader, {
      height: 200,
      style: {"width":"400px"},
      class: "fl"
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]),
      _: 1
    })
  ]))
}